import { c as _c } from "react/compiler-runtime";
import type { ReplyCountInput } from '@/orpc/client';
import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/orpc/client';
export function useCountReply(input) {
  const $ = _c(2);
  let t0;
  if ($[0] !== input) {
    t0 = orpc.reply.count.queryOptions({
      input
    });
    $[0] = input;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}